import {getBlogDetailsApi, getBlogListApi} from "@/api/blogApi";
import {Toast} from "vant";
import {formatTime} from '@/utils/timeFormatting';

export default {
    namespaced: true,
    methods: {},
    state () {
        return {
            blogList: [],
            blogDetails: {}
        }
    },
    mutations: {
        setBlogList (state, blogList) {
            state.blogList = blogList
        },
        setBlogDetails (state, blogDetails) {
            state.blogDetails = blogDetails
        }
    },
    actions: {
        async getBlogListAction (context) {
            try {
                const res = await getBlogListApi()
                // 列表 API 回傳 PageResult<Blog>：{ total, offset, limit, items }
                const items = (res.data && res.data.items) || []
                const filteredData = items.map(item => (
                    {
                        ...item,
                        formattedPostedAt: formatTime(item.postedAt)
                    })
                )
                context.commit('setBlogList', filteredData)
            } catch (error) {
                Toast(error.message || 'Failed to fetch blog list')
            }
        },
        async getBlogDetailsAction (context, blogId) {
            const res = await getBlogDetailsApi(blogId)
            if (res) {
                context.commit('setBlogDetails',
                    {
                        id: res.data.id,
                        title: res.data.title,
                        content: res.data.content,
                        formattedUpdatedAt: formatTime(res.data.updatedAt),
                        prevBlog: res.data.prevBlog,
                        nextBlog: res.data.nextBlog,
                    })
            }
        }
    },
    getters: {
        getBlogList: state => state.blogList,
        getBlogDetails: state => state.blogDetails,
    }
}


